import React from 'react';
import s from './s.module.less';
import ChooseMethod, { SetupMethod } from './ChooseMethod';
import NewNumberFlow from './NewNumberFlow';
import EnterNumber from './TransferFlow/EnterNumber';
import TransferForm from './TransferFlow/TransferForm';
import TransferSubmitted from './TransferFlow/TransferSubmitted';
import { Button, Modal } from 'antd';
import commonS from 'styles/common.module.less';
import EFaxLandingPage from '../EFaxLandingPage';

type Step = 'choose' | 'newSearch' | 'transferEnter' | 'transferForm' | 'transferSubmitted';

type Props = {
    onSetUp?: () => void;
};

const EFaxSetUpPage = ({ onSetUp }: Props) => {
    const [step, setStep] = React.useState<Step>('choose');
    const [transferNumber, setTransferNumber] = React.useState('');
    const [showLearnMore, setShowLearnMore] = React.useState(false);

    const handleMethodChosen = (method: SetupMethod) => {
        if (method === 'new') {
            setStep('newSearch');
        } else {
            setStep('transferEnter');
        }
    };

    const handleBack = () => {
        if (step === 'transferForm') {
            setStep('transferEnter');
        } else {
            setStep('choose');
        }
    };

    return (
        <div className={s.wrap}>
            <div className={s.titleBar}>
                <div className={s.pageTitle}>eFax</div>
                <Button onClick={() => setShowLearnMore(true)} className={s.learnMoreBtn}>
                    Learn more
                </Button>
            </div>
            <div className={step === 'newSearch' ? `${s.body} ${s.bodyNewNumberFlow}` : s.body}>
                {step === 'choose' && <ChooseMethod onContinue={handleMethodChosen} />}
                {step === 'newSearch' && (
                    <NewNumberFlow onBack={() => setStep('choose')} onConfirm={() => onSetUp?.()} />
                )}
                {step === 'transferEnter' && (
                    <EnterNumber
                        onBack={() => setStep('choose')}
                        onContinue={(num) => {
                            setTransferNumber(num);
                            setStep('transferForm');
                        }}
                    />
                )}
                {step === 'transferForm' && (
                    <TransferForm
                        transferNumber={transferNumber}
                        onBack={handleBack}
                        onSubmit={() => {
                            setStep('transferSubmitted');
                            onSetUp?.();
                        }}
                    />
                )}
                {step === 'transferSubmitted' && (
                    <TransferSubmitted transferNumber={transferNumber} onSetUpComplete={() => onSetUp?.()} />
                )}
            </div>
            <Modal
                open={showLearnMore}
                onCancel={() => {
                    setShowLearnMore(false);
                }}
                footer={null}
                width="84%"
                className={commonS.modalFixHeightWithoutPaddingWrap}
                title="Learn more about eFax"
            >
                <EFaxLandingPage isModal />
            </Modal>
        </div>
    );
};

export default EFaxSetUpPage;
